// extracted by mini-css-extract-plugin
export var clickableHeaderContent = "_fs-0";
export var headerCellHover = "_fs-1";
export var readCellContainer = "_fs-2";
export var unreadIndicator = "_fs-3";